/**
 * CRA only inlines env vars that are referenced as process.env.REACT_APP_*.
 * Always trim — Windows .env lines often carry trailing \\r which breaks Stripe.
 */
export const getStripePublishableKey = () => {
  const raw = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
  if (raw == null || raw === '') return ''
  return String(raw).trim().replace(/^["']|["']$/g, '')
}

export const getRazorpayKeyId = () => {
  const raw = process.env.REACT_APP_RAZORPAY_KEY_ID
  if (raw == null || raw === '') return ''
  return String(raw).trim().replace(/^["']|["']$/g, '')
}

/** Prefer publishable keys (pk_...) found anywhere in a booking/checkout payload */
export const findStripePublishableKeyInPayload = (payload, depth = 0) => {
  if (payload == null || depth > 6) return ''
  if (typeof payload === 'string') {
    const v = payload.trim()
    return v.startsWith('pk_') ? v : ''
  }
  if (typeof payload !== 'object') return ''
  if (Array.isArray(payload)) {
    for (let i = 0; i < payload.length; i += 1) {
      const found = findStripePublishableKeyInPayload(payload[i], depth + 1)
      if (found) return found
    }
    return ''
  }
  // Prefer known key names first
  const preferred = [
    'publishable_key',
    'stripe_publishable_key',
    'stripePublishableKey',
    'public_key',
    'publicKey',
    'pk',
  ]
  for (let i = 0; i < preferred.length; i += 1) {
    const v = payload[preferred[i]]
    if (typeof v === 'string' && v.trim().startsWith('pk_')) return v.trim()
  }
  const values = Object.values(payload)
  for (let i = 0; i < values.length; i += 1) {
    const found = findStripePublishableKeyInPayload(values[i], depth + 1)
    if (found) return found
  }
  return ''
}
